module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.8075/images/default-avatar.png"